import { render, staticRenderFns } from "./TrainingProtocolFormDialog.vue?vue&type=template&id=cc405b5e"
import script from "./TrainingProtocolFormDialog.vue?vue&type=script&lang=js"
export * from "./TrainingProtocolFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports